<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_4"></a>Copyright © 2013 by Anne Taintor, Inc.</p>
<p class="copyrightt">All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p class="copyrightat">ISBN 978-1-4521-2728-6</p>
<p class="copyrightt">The Library of Congress has cataloged the previous edition as follows:</p>
<p class="copyrightt">Taintor, Anne.</p>
<p class="copyrighta">But I wanted a pony! : an Anne Taintor motherhood collection / Anne Taintor.</p>
<p class="copyrightb">p. cm.</p>
<p class="copyrighta">ISBN 978-1-4521-1448-4</p>
<p class="copyright">1. Mothers--Humor. 2. Motherhood--Humor. I. Title.</p>
<p class="copyrighta">PN6231.M68T35 2013</p>
<p class="copyrighta">818’.602--dc23</p>
<p class="copyrightr">2012025099</p>
<p class="copyrightt">Designed by Emily Dubin</p>
<p class="copyright2">Chronicle Books LLC</p>
<p class="copyright">680 Second Street</p>
<p class="copyright">San Francisco, California 94107</p>
<p class="copyright"><span class="weblink"><a href="http://www.chroniclebooks.com" target="_blank">www.chroniclebooks.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0c3718bb